import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/ups_license_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .okay': 'close',
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/ups_license_modal.js